import { defaultClient } from '@/lib/client-type';
import { objectifyCookie } from 'shared/lib/cookie';
import { setBreakpoints } from 'shared/breakpoints';

export const getDefaultState = () => ({
  breakpoint: setBreakpoints(),
  loggedInUserId: 0,
  isLoggedIn: false,
  firstLoading: {},
  registerURLs: {
    google: null,
    microsoft: null,
  },
  loginURLs: {
    google: null,
    microsoft: null,
  },
  appVersion: '',
  semverVersion: '',
  foreignLogin: typeof objectifyCookie(document.cookie).foreign_login !== 'undefined',
  pageVisit: [],
  publicAccountData: null,
  clientInfo: defaultClient(),
  provisioningStatus: null,
  maintenanceMode: false,
  trashItems: { goal: [], count: { goal: undefined } },
  me: null,
  currentTenant: null,
  switchingAccount: false,
});
